import { render, staticRenderFns } from "./AssistanceInfomation.vue?vue&type=template&id=1ef679bb&scoped=true"
import script from "./AssistanceInfomation.vue?vue&type=script&lang=js"
export * from "./AssistanceInfomation.vue?vue&type=script&lang=js"
import style0 from "./AssistanceInfomation.vue?vue&type=style&index=0&id=1ef679bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef679bb",
  null
  
)

export default component.exports